import React from "react";

const Testata = ({imgurl: imgTestata, titolo, pre}) => {
  return (
    <div className="testata">
      <div className="testata__img">
        <img src={imgTestata} />
      </div>
      <div className="testata__caption">
        <div className="container">
          <div className="testata__content">
            {/* <h1>{titolo}</h1> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testata;
